import Page from 'modules/app/components/Page';

import s from './AllPostedVideos.module.scss';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import AllPostedVideosFilter from './AllPostedVideosFilter';
import AllPostedVideosHeader from './AllPostedVideosHeader';
import PostedVideo from '../Services/PostedVideo/PostedVideo';
import { useState } from 'react';
import BackHeader from '../BackHeader';

const AllPostedVideos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const handleBack = () => {
    const scrollPosition = location.state?.scrollPosition || 0;
    navigate(`/salon/${id}`, {
      state: {
        tab: 3,
        restoreScroll: true,
        scrollPosition: scrollPosition,
        fromBack: true,
      },
      replace: true,
    });
  };

  return (
    <Page disableOverflow activeLink="/venues">
      <BackHeader title="Posted Videos" onBack={handleBack} />
      <div className={s.all_videos_container}>
        <AllPostedVideosFilter onCategoryChange={setSelectedCategory} />
        <PostedVideo salonId={id} categoryId={selectedCategory} />
      </div>
    </Page>
  );
};

export default AllPostedVideos;
